import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import * as Store from '../../store';

import Header from '../header/header.vue';
import Sidebar from '../sidebar/sidebar.vue';
import Footer from '../footer/footer.vue';
import Login from '../../views/login/login.vue';

import router from '../../router';

// Styles and fonts
import '../../../node_modules/@mdi/font/css/materialdesignicons.min.css';
import '../../../node_modules/flag-icon-css/css/flag-icon.min.css';
import '../../../node_modules/font-awesome/css/font-awesome.min.css';

@Component({
    store: Store.store,
    components: {
        Header,
        Sidebar,
        Footer,
        Login,
    },
    router,
})
export default class Layout extends Vue {
    // eslint-disable-next-line no-useless-constructor
    constructor() {
        super();
    }

    // eslint-disable-next-line class-methods-use-this
    mounted() {}

    isLoggedIn() {
        return Store.readLoggedInState(this.$store);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/layout/index.ts